import React from 'react'

import { Icon, Verified } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import {
  ADVANCED_FILTER,
  CONTENT_FILTER,
  PERSONAL_FILTER,
  PURCHASE_FILTER,
} from 'Pods/SearchPage/Store/constants'

const advancedFilters = [
  {
    value: ADVANCED_FILTER.COLLECTIONS_ONLY,
    label: 'Packs',
  },
  {
    value: ADVANCED_FILTER.HAS_MARMOSET,
    label: 'Has 3D Viewer',
  },
  {
    value: ADVANCED_FILTER.HAS_VIDEO,
    label: 'Has Video',
  },
  {
    value: ADVANCED_FILTER.CGT_STANDARD_ONLY,
    label: 'CGT Standard',
    icon: Verified,
  },
]

const contentFilters = [
  {
    value: CONTENT_FILTER.ADULT_CONTENT_ONLY,
    label: 'Adult Content Only',
  },
  {
    value: CONTENT_FILTER.EXCLUDE_ADULT_CONTENT,
    label: 'Exclude Adult Content',
  },
]

const personalFilters = [
  {
    value: PERSONAL_FILTER.WISH_LIST_ONLY,
    label: 'Wish List Only',
  },
  {
    value: PERSONAL_FILTER.LIKED_MODELS_ONLY,
    label: 'Liked Models Only',
  },
]

const purchaseFilters = [
  {
    value: PURCHASE_FILTER.EXCLUDE_PURCHASED_MODELS,
    label: 'Exclude purchased items',
  },
  {
    value: PURCHASE_FILTER.PURCHASED_MODELS_ONLY,
    label: 'Purchased items only',
  },
]

export const advancedFiltersConfig = [{
  label: 'ADVANCED',
  filters: advancedFilters.map(filter => ({
    value: filter.value,
    label: filter.icon
      ? (
        <span className="filter-wrapper__option--with-icon">
          <span>{filter.label}</span>
          <Icon notSpaced svgComponent={filter.icon} color="primary" size="small" />
        </span>
      )
      : filter.label,
  })),
}]

export const contentFiltersConfig = [{
  label: 'CONTENT SAFETY',
  filters: contentFilters.map(filter => ({
    value: filter.value,
    label: filter.label,
  })),
}]

export const personalFiltersConfig = [{
  label: 'PERSONAL',
  filters: personalFilters.map(filter => ({
    value: filter.value,
    label: filter.label,
  })),
}]

export const purchaseFiltersConfig = [{
  label: 'PURCHASES',
  filters: purchaseFilters.map(filter => ({
    value: filter.value,
    label: filter.label,
  })),
}]
